import { render, staticRenderFns } from "./investorCard.vue?vue&type=template&id=f5f86956&scoped=true&"
import script from "./investorCard.vue?vue&type=script&lang=js&"
export * from "./investorCard.vue?vue&type=script&lang=js&"
import style0 from "./investorCard.vue?vue&type=style&index=0&id=f5f86956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f86956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5f86956')) {
      api.createRecord('f5f86956', component.options)
    } else {
      api.reload('f5f86956', component.options)
    }
    module.hot.accept("./investorCard.vue?vue&type=template&id=f5f86956&scoped=true&", function () {
      api.rerender('f5f86956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/startupProfile/investorCard.vue"
export default component.exports